import { Component, Input, OnInit } from '@angular/core';
import { IndependenceModel } from '../../declaration.model';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { CommonMessageService } from 'src/app/services/common-message.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as moment from 'moment';

@Component({
  selector: 'app-dpdp-declaration',
  templateUrl: './dpdp-declaration.component.html',
  styleUrls: ['./dpdp-declaration.component.css']
})
export class DpdpDeclarationComponent implements OnInit {

    financialList;
    employeeList;
    @Input() isMyReport: boolean;
    @Input() dpdpDeclaration: IndependenceModel;
  
    selectedFinancialYear;
    selectedProfile;
    selectedEmployee;
    constructor(
      private masterDataService: MasterDataService,
      private humanResourceService: HumanResourceService,
      private commonMessageService:CommonMessageService
    ) { }

  ngOnInit(): void {
    this.selectedProfile = "";
    this.selectedFinancialYear = "";
    this.selectedEmployee = "";

    if (!this.isMyReport) {
      this.loadInitDetails();
    }
  }

  loadInitDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onStatusSelect() {
    console.log('status select', this.selectedProfile);
    this.humanResourceService.getEmployeeProfile(this.selectedProfile).subscribe((res: any) => {
      this.employeeList = res;
      console.log('employee list', this.employeeList);
    })
  }

  onViewReport() {
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == "" ||
      this.selectedProfile == "" ||
      this.selectedProfile == null ||
      this.selectedProfile == undefined ||
      this.selectedEmployee == null ||
      this.selectedEmployee == undefined ||
      this.selectedEmployee == ""
    )
       this.commonMessageService.swalAlertWithoutIcon('','Please choose the values before pressing report');
    else {
      this.masterDataService
        .getDpdpIndependence(
          this.selectedFinancialYear.id,
          this.selectedEmployee.id,
          this.selectedProfile
        )
        .subscribe((res) => {
          this.dpdpDeclaration = res;
          console.log('clientIndependence', res);
          if (this.dpdpDeclaration == null) {
             this.commonMessageService.swalAlertWithoutIcon('',"No Record Found.");
              this.showPdfButton=false;
          }else {
            this.showPdfButton=true;
          }
          console.log('response', res);
        });
    }
  }

  validateAggreQuestion(answer) {
    if (answer == 1) {
      return true;
    } else {
      return false;
    }
  }

  showPdfButton:Boolean;
  exportToPDFClick(){
      var docDefinition = {
        pageOrientation: 'portrait',
        content: [
        ],
      };
  
      docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
      docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
      docDefinition.content.push({ text: "DATA PROTECTION CONSENT UNDER THE DIGITAL PERSONAL DATA PROTECTION ACT, 2023 ('the Act')", fontSize: 18, bold: true, alignment: 'center', margin: [0, 15, 0, 15] });
      docDefinition.content.push({text: `Name of Article/Employee/Partner:${'                      '}${this.dpdpDeclaration.firstName} ${this.dpdpDeclaration.lastName}`,bold:true,margin: [0, 5, 0, 5]});
      docDefinition.content.push({text: `Designation:${'                                                              '} ${this.dpdpDeclaration.role}`,bold:true,margin: [0, 5, 0, 5]});
      docDefinition.content.push({text: `Date Of Joining:${'                                                        '}${this.dpdpDeclaration.joiningDate}`,bold:true,margin:[0, 5, 0, 5]});
      docDefinition.content.push({text: `Branch:${'                                                                        '}${this.dpdpDeclaration.branch}`,bold:true,margin:[0, 5, 0, 5]});
      docDefinition.content.push({text: `Declaration For FY:${'                                                   '}${this.dpdpDeclaration.fyName}`,bold:true,margin:[0, 5, 0, 5]});
      docDefinition.content.push({text: `Definition of Personnel: ${this.dpdpDeclaration.beginText}`,bold:true,margin:[0, 5, 0, 10]});
  
      docDefinition.content.push({
          table: {
            headerRows: 1,
            widths: [40, '*', 60],
            body: [
              [{ text: 'Sr. No', bold:true, margin: [0, 5, 0, 5] }, { text: 'Declaration', bold:true, margin: [0, 5, 0, 5] }, { text: '	Agree / Disagree', bold:true, margin: [0, 5, 0, 5] }],
              ...this.dpdpDeclaration.empIndepenDeclarationDetails.map((res,index) => [{ text:index+1 }, { text: res.question},  { text: `${res.answer?'Yes':'No'}`}]),
             
            ]
          }
        }
        );
        docDefinition.content.push({text: 'Explanation in cases where disagree responses are given',margin:[0, 15, 0, 0],bold:true});
        docDefinition.content.push({text: `${this.dpdpDeclaration.dissagreementAnswer}`,margin:[0, 5, 0, 10]});
        docDefinition.content.push({text: `${this.dpdpDeclaration.endText}`,margin:[0, 5, 0, 5],bold:true});
        docDefinition.content.push({text: `Personnel Signature:${'                '} Yes`,margin: [0, 5, 0,4]});
        docDefinition.content.push({text: `Date:${'                                   '}${moment(this.dpdpDeclaration.signedDate).format('DD-MM-yyyy')}`,margin:[0, 4, 0, 4]});
  
      pdfMake.createPdf(docDefinition).download('DPDP_Declaration.pdf');
    }

}
